import React, { useRef, useEffect } from 'react';
import Illustration from './Illustration';
import c from './page-not-found.module.scss';
const PageNotFound = ({ action }) => {
  const pageRef = useRef();
  useEffect(() => {
    pageRef.current.focus();
  }, []);

  return (
    <div className={c.illustrationContainer}>
      <div className={c.shadow}>
        <Illustration.Shadow />
      </div>
      <div className={c.sun}>
        <Illustration.Sun />
      </div>
      <div className={c.planet}>
        <Illustration.Planet />
      </div>
      <div className={c.smallPlanetOne}>
        <Illustration.SmallPlanet />
      </div>
      <div className={c.smallPlanetTwo}>
        <Illustration.SmallPlanet />
      </div>

      <div className={c.smallerPlanetOne}>
        <Illustration.SmallerPlanet />
      </div>
      <div className={c.smallerPlanetTwo}>
        <Illustration.SmallerPlanet />
      </div>
      <div className={c.astronaut}>
        <Illustration.Astronaut />
      </div>
      <div className={c.tool}>
        <Illustration.Tool />
      </div>

      <div className={c.title} tabIndex={-1} ref={pageRef}>
        <h1>Oops! Lost in space?</h1>

        <span>The page you're looking for is not found.</span>

        {action && <div className={c.cta}>{action}</div>}
      </div>
    </div>
  );
};

export default PageNotFound;
